// FutureAnimation.js
import React from "react";
import Lottie from "react-lottie";
import futureAnimation from "./animations/future.json"; // Adjust the path as needed

const FutureAnimation = () => {
  const defaultOptions = {
    loop: true, // Replay continuously
    autoplay: true,
    animationData: futureAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div style={{ width: "100%", maxWidth: "500px", margin: "0 auto" }}>
      <Lottie options={defaultOptions} height={400} width={400} />
    </div>
  );
};

export default FutureAnimation;
